module.exports = __webpack_public_path__ + "img/af78e4eb927879507cb8cc58b5e52421.a8dbb6d9.jpg";